<template>
  <div class="collectListPage">
    <div class="titleBox">
      <div class="titleLeft" @click="goBack">
        <img src="../../assets/images/titleArrow.png" alt="" />
      </div>
      <div class="titleCentre">收藏</div>
      <div class="titleRight"></div>
    </div>

    <div class="listCard">
      <div
        class="listItem"
        v-for="(item, index) in collectList"
        :key="index"
        @click="goKnowledgeDetails(item)"
      >
        <div class="itemTitle">{{ index + 1 }}.{{ item.name || item.categoryName }}</div>
        <img class="itemArrow" src="../../assets/icons/right-arrow.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { statistics } from "@/api/knowledge/index.js";

export default {
  data() {
    return {
      collectList: [],
    };
  },
  created() {
    this.getCollectListData();
  },
  methods: {
    toValidNumber(value) {
      if (value === undefined || value === null || value === "") {
        return null;
      }
      const numberValue = Number(value);
      return Number.isNaN(numberValue) ? null : numberValue;
    },
    getRouteParams() {
      const paramsType = this.toValidNumber(this.$route.params.type);
      const paramsCode = this.toValidNumber(this.$route.params.code);
      const queryType = this.toValidNumber(this.$route.query.type);
      const queryCode = this.toValidNumber(this.$route.query.code);
      const pathParts = (this.$route.path || "").split("/").filter(Boolean);
      const pathType = this.toValidNumber(pathParts[pathParts.length - 2]);
      const pathCode = this.toValidNumber(pathParts[pathParts.length - 1]);

      const type = paramsType ?? queryType ?? pathType;
      const code = paramsCode ?? queryCode ?? pathCode;

      return { type, code };
    },
    async getCollectListData() {
      const { type, code } = this.getRouteParams();
      if (type === null || code === null) {
        this.collectList = [];
        return;
      }
      const { data } = await statistics(type, code);
      const sourceList = (data && data.agentMedicalKnowledgeNum) || [];
      this.collectList = Array.isArray(sourceList) ? sourceList : [];
    },
    goBack() {
      this.$router.go(-1);
    },
    goKnowledgeDetails(item) {
      const { type, code } = this.getRouteParams();
      this.$router.push({
        path: "/knowledgeDetails",
        query: {
          categoryId: item.categoryId,
          categoryName: item.categoryName,
          type,
          code,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.collectListPage {
  min-height: 100vh;
  background: #f4f5f8;

  .titleBox {
    padding: 44px 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .titleLeft,
    .titleRight {
      width: 24px;
      height: 24px;
    }

    .titleLeft {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .titleCentre {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 33px;
      transform: scale(0.5);
      transform-origin: center;
      color: #2f3445;
      white-space: nowrap;
    }
  }

  .listCard {
    margin: 14px 12px 0;
    background: #ffffff;
    border-radius: 12px;
    padding: 0 12px;

    .listItem {
      height: 62px;
      border-bottom: 1px solid #eceef4;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .itemTitle {
        font-family: PingFangSC, PingFang SC;
        font-size: 17px;
        color: #3b4053;
      }

      .itemArrow {
        width: 16px;
        height: 16px;
        opacity: 0.6;
      }
    }

    .listItem:last-child {
      border-bottom: none;
    }
  }
}
</style>
